import React from 'react';

/**
 * Async (code-split) entry point for AtlasHomeFomoSpotlightPlacement.
 *
 * Use this instead of the synchronous import to keep the Post Office headless
 * API and spotlight UI out of the main nav bundle. The chunk is only fetched
 * when the experiment gate `rovo_chat_fomo_spotlight_in_home` is enabled.
 */
export const AsyncAtlasHomeFomoSpotlightPlacement: React.LazyExoticComponent<
	typeof import('./AtlasHomeFomoSpotlightPlacement').AtlasHomeFomoSpotlightPlacement
> = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-onboarding/atlas-home-fomo-spotlight" */
		'./AtlasHomeFomoSpotlightPlacement'
	).then(({ AtlasHomeFomoSpotlightPlacement }) => ({
		default: AtlasHomeFomoSpotlightPlacement,
	})),
);

(
	AsyncAtlasHomeFomoSpotlightPlacement as React.ComponentType<
		React.ComponentProps<
			typeof import('./AtlasHomeFomoSpotlightPlacement').AtlasHomeFomoSpotlightPlacement
		>
	>
).displayName = 'AsyncAtlasHomeFomoSpotlightPlacement';
